import React, { useState, useEffect, useRef } from "react";
import styles from "./CleanupsFilter.module.scss";
import BasicCleanupsFilter from "./BasicCleanupsFilter/BasicCleanupsFilter";
import AdvancedCleanupsFilter from "./AdvancedCleanupsFilter/AdvancedCleanupsFilter";
import RepoweringCleanupsFilter from "./RepoweringCleanupsFilter/RepoweringCleanupsFilter";
import {
  CalciteBlock,
  CalciteTabs,
  CalciteTab,
  CalciteTabTitle,
  CalciteTabNav,
} from "@esri/calcite-components-react";
import config from "../../assets/config.json";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";

const CleanupsFilter = (props) => {
  // const sitesLayer = props.webmap.layers.find(
  //   (e) => e.title === config.layerNames.sitesLayer.title
  // );
  const sitesLayer = props.webmap.layers.items.find(
    (e) => e.allLayers && e.allLayers.items.find(
      (p: any) => p.title === config.layerNames.sitesLayer.title
      )
  )
  .allLayers.items.find(
    (p: any) => p.title === config.layerNames.sitesLayer.title
    )
  ;
  const [sitesLayerView, setSitesLayerView] = useState<any>(null);
  // shouldToggle and shouldClear are signal hooks to let basic/repowering know that they should toggle/clear their checkboxes
  const [shouldToggle, setShouldToggle] = useState<number>(Math.random());
  const [shouldClear, setShouldClear] = useState<number>(Math.random());
  // const hasLayerWatchers = useRef<boolean>(false);
  const filterThatIsFiltering = useRef<string>("");

  const generalToggleAll = () => {
    if (sitesLayerView !== null) {
      try {
        setShouldToggle(Math.random());
        sitesLayerView.filter = {
          where: "1=1",
        };
        reactiveUtils.whenOnce(() => sitesLayerView.updating === false).then(() => {
          sitesLayerView.visible = true;
          if (sitesLayer.visible === false) sitesLayer.visible = true;
        });
      } catch (e) {
        // handle error when adding filter or toggling visibility
      }
    } else {
      // handle for null sitesLayerView
    }
  };

  const generalClearAll = () => {
    setShouldClear(Math.random());
    if (sitesLayerView !== null) {
      try {
        sitesLayerView.filter = {
          where: "1=0",
        };
        reactiveUtils.whenOnce(() => sitesLayerView.updating === false).then(() => {
          sitesLayerView.visible = false;
          if (sitesLayer.visible === true) sitesLayer.visible = false;
        });
      } catch (e) {
        // handle error when adding filter or toggling visibility
      }
    } else {
      // handle for null sitesLayerView
    }
  };

  const generalSetLayerViewFilter = (where: string, sourceFilter: string) => {
    filterThatIsFiltering.current = sourceFilter;
    if (sitesLayerView !== null && sitesLayer) {
      try {
        sitesLayerView.layer.definitionExpression = null;
        sitesLayerView.filter = {
          where: where,
        };
        reactiveUtils.whenOnce(() => sitesLayerView.updating === false).then(() => {
          sitesLayerView.visible = true;
          if (sitesLayer.visible === false) sitesLayer.visible = true;
          filterThatIsFiltering.current = "";
        });
      } catch (e) {
        // handle error when adding filter or toggling visibility
      }
    } else {
      // handle for null sitesLayerView
    }
  };

  // const checkIfShouldToggle = () => {
  // }

  // const checkIfShouldClear = () => {
  // }


  // if (!hasLayerWatchers.current) {
  //   watchUtils.when(sitesLayer, "visible", () => {
  //     checkIfShouldToggle();
  //   });
  //   watchUtils.whenNot(sitesLayer, "visible", () => {
  //     checkIfShouldClear();
  //   });
  //   hasLayerWatchers.current = true;
  // }

  useEffect(() => {
    if (props.isBrownfieldRoute)  {
      // generalClearAll();
      setShouldClear(Math.random());
    }
  },[])

  useEffect(() => {
    if (sitesLayerView === null) {
      try {
        props.view.when(async () => {
          await props.view.whenLayerView(sitesLayer).then((layerView) => {
            setSitesLayerView(layerView);
          });
        });
      } catch (e) {
        console.error("could not retrieve layer view for sites layer");
      }
    }
  });

  useEffect(() => {
    // if (!hasLayerWatchers) {
    //   watchUtils.when(sitesLayer, "visible", () => {
    //     checkIfShouldToggle();
    //   });
    //   watchUtils.whenNot(sitesLayer, "visible", () => {
    //     checkIfShouldClear();
    //   });
    //   setHasLayerWatchers(true);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sitesLayerView, sitesLayer, filterThatIsFiltering.current]);

  return sitesLayerView !== null ? (
    <div className={styles.cleanupsFilter}>
      <CalciteBlock
        heading={"Cleanups"}
        description={"See filter options for cleanup sites - please be sure to click the blue Filter button after making changes to the checkbox selections"}
        collapsible
        open
      >
        <CalciteTabs>
          <CalciteTabNav slot="title-group">
            <CalciteTabTitle>Basic Filters</CalciteTabTitle>
            <CalciteTabTitle>Advanced Filters</CalciteTabTitle>
            <CalciteTabTitle>Re-Powering Filters</CalciteTabTitle>
          </CalciteTabNav>
          <CalciteTab title={"Basic Filters"}>
            <BasicCleanupsFilter
              siteType={props.siteType !== null ? props.siteType : null}
              generalClearAll={generalClearAll}
              generalToggleAll={generalToggleAll}
              generalSetLayerViewFilter={generalSetLayerViewFilter}
              // Bubble up the basic-filter clause array to MenuPanel for sibling access.
              updateCleanupParamArray={props.updateCleanupParamArray}
              updateActiveCleanupFilterType={props.updateActiveCleanupFilterType}
              updateBasicCleanupFilterDescription={props.updateBasicCleanupFilterDescription}
              shouldToggle={shouldToggle}
              shouldClear={shouldClear}
            />
          </CalciteTab>
          <CalciteTab title={"Advanced Filters"}>
            <AdvancedCleanupsFilter
              sitesLayer={sitesLayer}
              view={props.view}
              sitesLayerView={sitesLayerView}
              updateAdvancedCleanupParamArray={props.updateAdvancedCleanupParamArray}
              updateAdvancedCleanupMatchesAny={props.updateAdvancedCleanupMatchesAny}
              updateActiveCleanupFilterType={props.updateActiveCleanupFilterType}
              updateAdvancedCleanupFilterDescription={props.updateAdvancedCleanupFilterDescription}
            />
          </CalciteTab>
          <CalciteTab title={"Re-Powering Filters"}>
            <RepoweringCleanupsFilter
              generalClearAll={generalClearAll}
              generalToggleAll={generalToggleAll}
              generalSetLayerViewFilter={generalSetLayerViewFilter}
              shouldToggle={shouldToggle}
              shouldClear={shouldClear}
            />
          </CalciteTab>
        </CalciteTabs>
      </CalciteBlock>
    </div>
  ) : (
    <></>
  );
};

export default CleanupsFilter;
